<template>
  <b-container>
    <h1>{{ $t("tracking.cargo.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
      <b-button class="ml-2" size="sm" @click="newCargo()">{{
        $t("geral.create")
      }}</b-button>
    </b-row>

    <b-form @submit.prevent="save">
      <b-row>
        <b-col sm="12" md="6" lg="6">
          <cargo-crud-data
            ref="cargoCrudData"
            :model="model"
            :modelstate="modelstate"
            :readonly="false"
            :create="true"
            class="mb-4"
          >
          </cargo-crud-data>
          <!-- {{model.cargoPath}} -->
          <cargo-path
            :items.sync="model.cargoPath"
            :carga="model"
            :modelstate="modelstate"
            :readonly="true"
          >
          </cargo-path>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button type="submit" :disabled="submitted">
            {{ $t("geral.save") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "CargoCreate",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CargoCrudData: () =>
      import("@/components_rms/tracking/cargo/CargoCrudData.vue"),
    CargoPath: () => import("@/components_rms/tracking/cargo/CargoPath.vue"),
  },
  props: {
    companyId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {},
    };
  },
  created() {
    this.newModel();
  },
  computed: {
    getUrlBackToList() {
      if (this.companyId) {
        return `../cargo/list/${companyId}`;
      }
      return `../cargo/list`;
    },
  },
  methods: {
    newCargo() {
      this.newModel();
      this.$forceUpdate();
      this.modelstate = {};
      this.submitted = false;
    },
    newModel() {
      this.model = {
        cargoActive: true,
        cargoTypeId: 1,
        clientName: "",
        additionalInformation: "",
        clientDocumentType: "CNPJ",
        clientCompanyDocument: "",
        clientPersonalDocument: "",
        companyId: "",
        companyBranchName: "",
        dateAttendance: "",
        dateAttendanceExpiration: "",
        dateDeliveryForecast: "",
        destinationCityId: null,
        destinationCityName: "",
        destinationStateId: null,
        originCityId: null,
        originCityName: "",
        originStateId: null,
        status: 2,
        vehicleTypeName: "",
        weight: 0.0,
        transportNumber: "",
        shipperDocument: "",
        shipperName: "",
        serviceTakerDocument: "",
        serviceTakerName: "",
        // isStatusSearchVehicle
        Driver: null,
        VehiclePlate: null,
        // isStatusChecklistLoading
        ChecklistId: null,
        // isStatusScheduler
        CollectionOrder: null,
        // isStatusWaitingCollect
        // isStatusLoading
        LoadingCteNumber: null,
        LoadingManifestNumber: null,
        LoadingContractNumber: null,
        LoadingCiotNumber: null,
        // isStatusInTraffic
        TransportStartDate: null,
        // isStatusWaitingUnload
        ArrivalDateAtDestination: null,
        // isStatusUnloading
        UnloadStartDate: null,
        // isStatusDelivered
        DeliveryDate: null,
        tripTotalKm: null,
        cargoPath: [
          // {
          //   destinationCityId: 0,
          //   destinationCityName: "",
          //   destinationStateId: 0,
          //   destinationStateAbrev: "",
          //   originCityId: 0,
          //   originCityName: "",
          //   originStateId: 0,
          //   originStateAbrev: "",
          //   nfeNumber: "",
          //   cteNumber: "",
          //   manifestNumber: "",
          //   ciotNumber: "",
          //   freightContract: ""
          // },
        ],
      };
    },
    tripTotalKmType() {
      if (this.model.tripTotalKm === "" || this.model.tripTotalKm == 0) {
        return (this.model.tripTotalKm = null);
      }
    },
    save() {
      this.submitted = true;
      this.$refs.cargoCrudData.dataFormat();

      let urlPost;
      if (this.model.cargoId > 0) {
        urlPost = "/cargo/edit/" + this.model.cargoId.toString();
      } else {
        urlPost = "/cargo/create";
      }

      this.tripTotalKmType();

      this.$api
        .post(urlPost, this.model)
        .then((response) => {
          this.model = response.data;
          this.$forceUpdate();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            if (error.response.status == 400) {
              if (error.response.data.errors) {
                this.modelstate = error.response.data.errors;
              } else {
                this.modelstate = error.response.data;
              }
              this.alert.error = error.message;
            } else if (error.response.status == 404) {
              console.log(error.response.data);
              this.alert.error = error.response.data.message;
            } else {
              if (error.response.data) {
                console.log(error.response.data);
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.fadeAlertDanger.show();
        });
    },
  },
};
</script>
